module.exports = __webpack_public_path__ + "static/media/atef3.8944ad2e.webp";